import {MeterSelectorProps, metersSelector, useGetAllMetersQuery} from "@ots-frontend/ots-data";
import {BaseMeterSelect, BaseMeterSelectProps} from "./BaseMeterSelect";
import {useMemo} from "react";

type Props = Omit<BaseMeterSelectProps, "entities" | "loading"> & {
    selector?: MeterSelectorProps
}

export const MeterSelect = (props: Props) => {
    const {selector, ...rest} = props;

    const selectMeters = useMemo(() => {
        return metersSelector()
    }, [])

    const {meters, isLoading} = useGetAllMetersQuery(selector?.regionId, {
        selectFromResult: (result) => ({
            meters: selectMeters(result, selector),
            isLoading: result.isLoading,
        })
    });

    return <BaseMeterSelect entities={meters} loading={isLoading} {...rest} />;
};
